import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UserdataService } from '../shared/userdata/userdata.service';

@Injectable({
  providedIn: 'root'
})
export class GuidanceService {
  BaseUrl: string = ''
  Token: any = '';

  constructor(
    private http: HttpClient, @Inject('BASE_URL') _base: string,
    private userdata: UserdataService
  ) {
    this.BaseUrl = _base
    this.Token = userdata.getData()
  }

  /**
   * Guidance Category 
   */

  public addGuidanceCategory(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceCategory/add", data, { headers: header_object });
  }

  public getGuidanceCategory(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceCategory/all", data, { headers: header_object });
  }

  public getSingleGuidanceCategory(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceCategory/single", data, { headers: header_object });
  }

  public updateGuidanceCategory(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceCategory/update", data, { headers: header_object });
  }

  /**
  * Guidance Cards 
  */

  public getGuidanceCards(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceCard/all", data, { headers: header_object });
  }

  public getSingleGuidanceCard(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceCard/single", data, { headers: header_object });
  }
  public updateGuidanceCard(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceCard/update", data, { headers: header_object });
  }

  public addGuidanceCard(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceCard/add", data, { headers: header_object });
  }
  
  /**
  * Guidance Detail 
  */

  public getGuidanceDetail(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceDetail/all", data, { headers: header_object });
  }

  public getSingleGuidanceDetail(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceDetail/single", data, { headers: header_object });
  }
  public updateGuidanceDetail(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceDetail/update", data, { headers: header_object });
  }

  public addGuidanceDetail(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/guidanceDetail/add", data, { headers: header_object });
  }


  /**
  * Guidance Orders 
  */

   public getGuidanceOrders(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/orderGuidance/all", data, { headers: header_object });
  }
   public getSingleGuidanceOrder(data: any) {
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/orderGuidance/single", data, { headers: header_object });
  }


}
